<template>
  <div>
    <v-app-bar color="primary" dark flat>
      <v-app-bar-nav-icon v-if="$route.path === '/admin'" @click="drawer = true" />

      <v-container fill-height>
        <v-img max-width="90px" :src="require('@/assets/logo-white.svg')" contain />

        <v-spacer />

        <LanguageSwitcher />
        <HeaderUser v-if="$route.name !== 'Login'" />
      </v-container>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" color="primary" absolute temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group">
          <v-list-item class="mb-12 pb-12">
            <v-img :src="require('@/assets/logo-white.svg')" contain />
          </v-list-item>

          <v-list-item dark class="mt-12" @click="setDisplay('home')">
            {{ $t('MENU_SECTION_HOME') }}
          </v-list-item>

          <v-list-item dark @click="setDisplay('offers')">
            {{ $t('MENU_SECTION_OFFERS') }}
          </v-list-item>

          <v-list-item dark @click="setDisplay('models')">
            {{ $t('MENU_SECTION_RATE_MODELS') }}
          </v-list-item>

          <v-list-item dark @click="setDisplay('translations')">
            {{ $t('MENU_SECTION_TRANSLATIONS') }}
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import HeaderUser from '@/components/header-user/HeaderUser'
import LanguageSwitcher from '@/components/language-switcher/LanguageSwitcher'
import { mapMutations } from 'vuex'

export default {
  name: 'MainHeader',
  components: {
    HeaderUser,
    LanguageSwitcher,
  },
  data() {
    return {
      drawer: false,
      group: null,
    }
  },
  methods: {
    ...mapMutations('process', ['setAdminDisplay']),
    setDisplay(display) {
      this.setAdminDisplay(display)
    },
  },
  watch: {
    group() {
      this.drawer = false
    },
  },
  mounted() {
    const { section } = this.$route.query
    if (section && ['offers', 'models', 'translations'].includes(section)) {
      this.setDisplay(section)
    }
  },
}
</script>
